module.exports = __webpack_public_path__ + "static/img/logo.cf7766a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 60
// module chunks = 1